import mainStyle from "../../mainStyle.module.scss";
import React, { useState, useEffect, useRef } from 'react';
import { cloneDeep } from "lodash";
import { useTheme } from "@mui/material/styles";
import { Typography, Box } from "@mui/material";
import useDataSourceManager from "hooks/useDataSourceManager";

import { OutlineRectangleButton } from "components/buttons/OutlineRectangleButton";

import { ReactComponent as SendIcon } from "assets/images/icons/icn_btn_resend.svg";

const clientSecret = process.env.REACT_APP_CLIENT_SECRET;
const orgID = process.env.REACT_APP_ORGANIZATIONNAME;
const appID = process.env.REACT_APP_APPNAME;

const MfaPhase3 = (props) => {
  const {
    userSetting, setInputOpt
  } = props;
  const theme = useTheme();
  const { dataMap, getData, decodeTokenData, sendRequest, sendBatch } = useDataSourceManager();

  const [count, setCount] = useState(0);
  const [isCounting, setIsCounting] = useState(false);

  const inputsRef = useRef([]);
  const [otp, setOtp] = useState(['', '', '', '', '', '']);

  const handleSnedMail = () =>{
    if (!isCounting) {
      setCount(60);
      setIsCounting(true);
      sendVerifyMail()
    }
  }

  // const getCaptcha = async() => {
  //   const updateData = new URLSearchParams();
  //   updateData.append("applicationId", 'admin/'+appID);
  //   updateData.append("isCurrentProvider", 'false');
  //   const response = await UserService.getCaptcha('admin/'+appID, false)
  // }

  const sendVerifyMail = async() => {
    // const updateData = new URLSearchParams();
    // updateData.append("captchaType", 'Cloudflare Turnstile');
    // updateData.append("captchaToken", '');
    // updateData.append("clientSecret", clientSecret);
    // updateData.append("method", 'mfaSetup');
    // updateData.append("countryCode", '');
    // updateData.append("dest", userSetting.email);
    // updateData.append("type", 'email');
    // updateData.append("applicationId", 'admin/'+appID);
    // updateData.append("ignoreCaptcha", true);
    
    let updateData = {
      captchaType: 'Cloudflare Turnstile',
      captchaToken: '',
      /* clientSecret: clientSecret, */
      method: 'mfaSetup',
      countryCode: '',
      dest: userSetting.email,
      type: 'email',
      applicationId: 'admin/'+appID,
      ignoreCaptcha: true,
    }

    // const response = await UserService.sendVerifyMail(updateData, token)
    const response = await sendRequest("casdoor/UserService/.sendVerifyMail",
      null, null, updateData
    );
    if(response.status === 'ok'){
    }else{
    }
  }

  useEffect(() => {
    handleSnedMail();
  }, []);

  useEffect(() => {
    let timer;
    if (isCounting && count > 0) {
      timer = setTimeout(() => setCount((prev) => prev - 1), 1000);
    } else if (count === 0 && isCounting) {
      setIsCounting(false);
    }
    return () => clearTimeout(timer);
  }, [count, isCounting]);

  const handleChange = (e, index) => {
    // console.log('handleChange')
    // console.log(e.target.value, index)
    let tmpVal = e.target.value;

    if (!/^\d*$/.test(e.target.value)) {
      return;
    }

    let tmpOTP = cloneDeep(otp)
    if(tmpVal!=='' && tmpOTP[index]!==''){ //空值才能輸入
      if(index < otp.length-2 && tmpOTP[index+1]===''){
        let letter = tmpVal[tmpVal.length - 1];
        tmpOTP[index+1] = letter;
        setOtp(tmpOTP)
        setInputOpt(tmpOTP)
        inputsRef.current[index + 2]?.focus();
      }else{
        if(tmpVal.length === 1){
          tmpOTP[index] = tmpVal;
          setOtp(tmpOTP)
          setInputOpt(tmpOTP)
          inputsRef.current[index + 1]?.focus();
        }else{
          // console.log('back')
          return;
        }
      }
    }else{
      tmpOTP[index] = tmpVal;
      setOtp(tmpOTP)
      setInputOpt(tmpOTP)
      if(tmpVal!==''){ // 輸入往後推一格
        inputsRef.current[index + 1]?.focus();
      }else{ // 回車往前推ㄧ格
        inputsRef.current[index - 1]?.focus();
      }
    }
    
  }
  const handleKeyDown = (e, index) => {
    // console.log('handleKeyDown')
    // console.log(e.target.value)
    // console.log(e.key)
    // console.log(index)
    if(e.key === 'Enter'){
      if(index < otp.length-1) { // 輸入往後推一格
        inputsRef.current[index + 1]?.focus();
      }
    // }
    // else if(e.key === 'ArrowLeft'){
    //   if(index > 0){ // 回車往前推ㄧ格
    //     inputsRef.current[index - 1]?.focus();
    //   }
    }else if(e.key === 'Backspace' && e.target.value === ''){
      if(index > 0){ // 回車往前推ㄧ格
        inputsRef.current[index - 1]?.focus();
      }
    }
  }

  return (
    <>
      <div className={mainStyle['modal_rows']} >
        <div className={mainStyle['modal_Block']}>
          <Typography
            sx={{
              color: theme.palette.primary.greyPrimary,
              fontSize: theme.typography.customFontSize[4],
              fontFamily: theme.typography.fontFamily,
            }}
            >
            An Email with a verification code has been sent to
          </Typography>
        </div>
        <div className={mainStyle['modal_Block']}>
          <Typography
            sx={{
              color: theme.palette.primary.greyPrimary,
              fontSize: theme.typography.customFontSize[4],
              fontWeight: theme.typography.customFontWeight[3],
              fontFamily: theme.typography.fontFamily,
            }}
            >
            {userSetting.email}
          </Typography>
        </div>
        <div className={mainStyle['modal_Block']} style={{gap:'5px'}}>
          <Typography
            sx={{
              color: theme.palette.primary.greyPrimary,
              fontSize: theme.typography.customFontSize[4],
              fontFamily: theme.typography.fontFamily,
            }}
            >
            Varification code expires after
          </Typography>
          <Typography
            sx={{
              color: theme.palette.primary.greyPrimary,
              fontSize: theme.typography.customFontSize[4],
              fontWeight: theme.typography.customFontWeight[3],
              fontFamily: theme.typography.fontFamily,
            }}
            >
            10
          </Typography>
          <Typography
            sx={{
              color: theme.palette.primary.greyPrimary,
              fontSize: theme.typography.customFontSize[4],
              fontFamily: theme.typography.fontFamily,
            }}
            >
            minutes
          </Typography>
        </div>
      </div>
      <div className={mainStyle['modal_rows']} >
        <div style={{marginTop: '15px'}}>
          <Typography
            sx={{
              color: theme.palette.primary.greyPrimary,
              fontSize: theme.typography.customFontSize[4],
              fontFamily: theme.typography.fontFamily,
            }}
            >
            Enter verify code
          </Typography>
        </div>
        <div className={mainStyle["modal_verifyCode"]}
          style={{marginTop: '15px', display:'flex', justifyContent:'center', alignItems:'center'}}>
          <div style={{marginRight: '30px',  display:'flex', gap:'10px'}}>
            {otp.map((value, index) => (
              <input
              className={`
                ${value===''||value===null? mainStyle['modal_verifyCode_empty']:mainStyle['modal_verifyCode_pass']}`}
                key={index}
                value={value}
                // id={`input-${index}`}
                // type="number"
                onChange={(e) => handleChange(e, index)}
                onKeyDown={(e) => handleKeyDown(e, index)}
                ref={(element) => (inputsRef.current[index] = element)}
              />
            ))}
          </div>
          <Box>
            <OutlineRectangleButton 
              startIcon={<SendIcon />}
              width="100px"
              height="42px"
              onClick={handleSnedMail}
              disabled={(isCounting === true)?true:false}
            >
              {(isCounting === true)?count+' s':'Send'}
            </OutlineRectangleButton>
          </Box>
        </div>
      </div>
    </>
  );
}

export default MfaPhase3;